// extracted by mini-css-extract-plugin
export default {"p":"_9b7ec47c3e c419eb7487 d5602986d6","clr":"c92fb7b8bf","dls":"a84e488c21"};